import React from 'react';
import { dataHooks } from '../../datahooks';
import { Box, Heading, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import s from './CategoriesHeader.scss';

export const CategoriesHeader: React.FC<{}> = () => {
  const { t } = useTranslation();

  return (
    <Box direction="vertical" gap={8}>
      <Box direction="vertical" boxSizing="border-box" gap={1}>
        <Heading size="large" dataHook={dataHooks.HeaderTitle}>
          {t('STEP1_HEADER')}
        </Heading>

        <Box direction="vertical" gap={1} dataHook={dataHooks.HeaderSubtitle}>
          <Text className={s.secondaryText} size="medium">
            {t('STEP1_SUB_HEADER_MOBILE')}
          </Text>

          <Text>{t('STEP_SUB_HEADER_CHOOSE')}</Text>
        </Box>
      </Box>
    </Box>
  );
};
